import React from 'react';
import QmsArchiveAsset, { managedArchivePath } from '../components/QmsArchiveAsset';
import { safeSourceUrl } from '../components/qmsAuthoring';

export default function ChangeReference({ asset, compact = false }) {
  if (managedArchivePath(asset?.url)) return <QmsArchiveAsset asset={asset} compact={compact} preview={false} />;
  const url = safeSourceUrl(asset?.url);
  return <div style={{ overflowWrap: 'anywhere' }}><strong>{asset?.title || 'Reference'}</strong>{url
    ? <> · <a href={url} target="_blank" rel="noopener noreferrer">Open reference</a></>
    : <span> — reference unavailable</span>}</div>;
}
